/**
 * @copyright
 * Copyright (c) 2024 Accretive Technology Group, Inc. All rights
 * reserved. For use only by Accretive Technology, its employees
 * and contractors. DO NOT DISTRIBUTE.
 */
import { isAxiosError } from "axios";
import { t } from "i18next";

import { AsyncThunkError } from "~/state/types";
import { ApiMessageConfig, WebserviceResponse } from "~/types";
import createThunkError from "~/utils/createThunkError";

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const getAsyncThunkError: (error: any, config: ApiMessageConfig) => AsyncThunkError = (error, config) => {
  const unknownError = t("error.unknown_error", { ns: "common" });

  if (isAxiosError(error)) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const response = error.response?.data as WebserviceResponse<any>;
    const key = Object.keys(config).find((errorMessage) => errorMessage === response?.error);
    const message = key ? t(config[key].key, { ns: config[key].namespace }) : unknownError;
    const errorCode = error.status;

    return createThunkError({ apiErrorCode: errorCode ?? 400, message });
  }
  return createThunkError({ apiErrorCode: 500, message: unknownError });
};

export default getAsyncThunkError;
